import { string, shape, bool, object, oneOfType } from 'prop-types';

export default shape({
  _id: string.isRequired,
  value: oneOfType([string, object]).isRequired,
  type: oneOfType([string, object]).isRequired,
  hidden: bool.isRequired,
  muted: bool,
  title: string.isRequired
});
